import { Outlet } from 'react-router-dom';
import { MobileFooter } from './mobile-footer';
import { cn } from '@/utils';
import { useLabels } from '@/api/useLabels';
import { useSettingsStore } from '@/stores/settingsStore';

export function MobileLayout() {
  const isIOS = /^((?!chrome|android|crios|fxios).)*safari/i.test(navigator.userAgent) && /iPad|iPhone|iPod/.test(navigator.userAgent);

  const currentEventId = useSettingsStore(state => state.eventId);
  const languageCode = useSettingsStore(state => state.languageCode);

  const { isLoading } = useLabels({
    eventId: currentEventId!,
    languageCode: languageCode ?? 'swe',
    config: {
      enabled: !!currentEventId,
    },
  });

  if (isLoading) return null;

  return (
    <div className="flex flex-col">
      <main className={cn('flex-1 overflow-y-auto', isIOS ? 'max-h-[calc(100dvh_-_80px)]' : 'max-h-[calc(100dvh_-_60px)] pb-4')}>
        <Outlet />
      </main>
      <MobileFooter />
    </div>
  );
}
